module.exports = __webpack_public_path__ + "img/teams-grid-zoom-plus-clicked.1d3c86c2.svg";